"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/icons/external/Clover` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const Clover = createSVGIcon(
  <path
    d="M11.195 5.658c0-2.306-1.38-4.266-3.449-5.188a5.46 5.46 0 0 0-6.094 1.153C.042 3.237-.417 5.658.388 7.734s2.874 3.459 5.174 3.459h5.633zm1.61 0c0-2.306 1.38-4.266 3.449-5.188a5.46 5.46 0 0 1 6.094 1.153c1.61 1.614 2.069 4.035 1.264 6.111s-2.874 3.459-5.174 3.459h-5.633zm0 12.684c0 2.305 1.38 4.266 3.449 5.188a5.46 5.46 0 0 0 6.094-1.153c1.61-1.614 2.069-4.035 1.264-6.111s-2.874-3.459-5.174-3.459h-5.633zm-7.243 4.035a4.005 4.005 0 0 0 4.024-4.035v-4.036H5.562a4.005 4.005 0 0 0-4.024 4.036 4.005 4.005 0 0 0 4.024 4.035m5.633-4.035c0 2.305-1.38 4.266-3.449 5.188a5.46 5.46 0 0 1-6.094-1.153C.042 20.763-.417 18.342.388 16.266s2.874-3.459 5.174-3.459h5.633z"
    fill="#280"
  />,
  "Clover",
  { viewBox: "0 0 24 24", fill: "none", className: legacyIconCls() } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
